import { BigNum, PRICE_PRECISION_EXP } from '@drift-labs/sdk';
import { MarketId } from '@drift/common';
import { memo } from 'react';
import useDriftStore from '../../stores/DriftStore/useDriftStore';
import { PriceChangePercentDisplay } from './PriceChangePercentDisplay';
import DefinitionTooltip from 'src/components/Tooltip/DefinitionTooltip/DefinitionTooltip';
import { getMarketPriceDecimals } from 'src/constants/marketDecimalConfig';
import useIsMobileScreenSize from 'src/hooks/useIsMobileScreenSize';
import NumberDisplay from '../NumberDisplay/NumberDisplay';
import { cm } from 'src/utils/classNames';

interface Props {
	loading: boolean;
	price: string;
	className?: string;
	marketId?: MarketId;
}

function MarkPriceDisplay({ loading, price, className, marketId }: Props) {
	const isMobileScreenSize = useIsMobileScreenSize();

	const currentMarket = useDriftStore((s) => s.selectedMarket.current);
	const marketSymbol = currentMarket?.baseAssetSymbol() || '';
	const priceDecimals = getMarketPriceDecimals(marketSymbol);

	const markPrice = price
		? BigNum.from(price, PRICE_PRECISION_EXP)
		: BigNum.zero();

	return (
		<DefinitionTooltip
			decoration="cursor-help"
			definitionId="tradingMarkPrice"
			disabled={isMobileScreenSize}
		>
			<div className={cm('flex flex-col items-start', className)}>
				{/* Large price display */}
				<NumberDisplay
					value={markPrice}
					type="currency"
					decimals={priceDecimals}
					loading={loading}
					skeletonClassName="w-20 h-2xl"
					className="typo-t2 text-text-default md:typo-t1"
				/>

				{/* Percentage change below */}
				{marketId && (
					<PriceChangePercentDisplay
						marketId={marketId}
						markPrice={markPrice}
						className="typo-b3"
					/>
				)}
			</div>
		</DefinitionTooltip>
	);
}

export default memo(MarkPriceDisplay);
